import { Options } from "@sprout/select";
import usStates from "@lib/shared/us_states.json";

export const US_STATES: Options = usStates as Options;
